import React, { Fragment, useState } from "react";
import {
    TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import sendRequest from '../utils/sendRequest';
import { SubmitButton, CancelButton, MenuButtonIcon } from "../styled/CustomButtons";

export default function CreatePoDialog({ addSnackbar, fetchPos, lux, oak, essx }) {
    const [open, setOpen] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [currency, setCurrency] = useState("");
    const [type, setType] = useState("");

    const handleOpen = () => {
        setOpen(true);
        setCurrency("");
        setType("");
    };

    const handleClose = () => {
        if (!loadingCreate) {
            setOpen(false);
        }
    };

    const createPurchaseOrder = async (name, currency, type) => {
        setLoadingCreate(true);
        try {
            const response = await sendRequest(
                `purchase-orders?po_name=${encodeURIComponent(name)}&po_type=${encodeURIComponent(type)}&currency=${encodeURIComponent(currency)}`,
                null,
                'POST'
            );
            fetchPos();
            addSnackbar(response.message);
        } catch (error) {
            addSnackbar(error.message, false);
        } finally {
            setLoadingCreate(false);
            handleClose();
        }
    };

    return (
        <Fragment>
            <MenuButtonIcon
                isIcon={true}
                title={"Create PO"}
                icon={AddCircleIcon}
                iconProps={{ sx: { fontSize: 50 }}}
                onClick={handleOpen}
                variant=''
                sx={{ color: 'primary.main', padding: 0 }}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                disableEscapeKeyDown={loadingCreate}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        createPurchaseOrder(formJson.name, currency, type);
                    },
                    autoComplete: 'off',
                }}
            >
                <DialogTitle>Create Purchase Order</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Please enter the name, PO type, and currency for the new Purchase Order.
                    </DialogContentText>

                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="name"
                        label="PO Name"
                        type="text"
                        fullWidth
                        variant="standard"
                    />

                    <FormControl fullWidth variant="standard" margin="dense" required>
                        <InputLabel id="type-label">PO Type</InputLabel>
                        <Select
                            labelId="type-label"
                            id="type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            label="PO Type"
                            required
                        >
                            {lux && <MenuItem value={'LUX'}>LUX</MenuItem>}
                            {oak && <MenuItem value={'OAK'}>OAK</MenuItem>}
                            {essx && <MenuItem value={'ESSX'}>ESSX</MenuItem>}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth variant="standard" margin="dense" required>
                        <InputLabel id="currency-label">Currency</InputLabel>
                        <Select
                            labelId="currency-label"
                            id="currency"
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value)}
                            label="Currency"
                            required
                        >
                            <MenuItem value={'USD'}>USD</MenuItem>
                            <MenuItem value={'EUR'}>EUR</MenuItem>
                            <MenuItem value={'GBP'}>GBP</MenuItem>
                            <MenuItem value={'JPY'}>JPY</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <CancelButton onClick={handleClose} disabled={loadingCreate}>Cancel</CancelButton>
                    <SubmitButton
                        showSpinner={loadingCreate}
                        text={"Submit"}
                        type="submit"
                        disabled={loadingCreate || !currency || !type}
                    />
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
